import styled from 'styled-components';

import { Paper, Typography } from '@mui/material';

export const StyledPaper = styled(Paper)`
    padding: 16px;
    border-radius: 12px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const TableWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-x: auto;
`;

export const StyledTitle = styled(Typography)`
    color: darkgreen;
    font-weight: bold;
    text-align: center;
`;
